import {bootstrapApplication} from '@angular/platform-browser';

import {AppComponent} from "./app/root/app/app.component";
import {provideRouter, Routes} from "@angular/router";
import {MailingComponent} from "./app/admin/mailing/mailing.component";
import {SignInComponent} from "./app/auth/signin/sign-in.component";
import {SignUpComponent} from "./app/auth/signup/sign-up.component";
import {PasswordResetComponent} from "./app/auth/password-reset/password-reset.component";
import {PinholeComponent} from "./app/admin/pinhole/pinhole.component";
import {PermissionsService} from "./app/admin/permissions.service";
import {RoundComponent} from "./app/round/round.component";
import {UnsubscribeComponent} from "./app/unsubscribe/unsubscribe.component";
import {RoundHistoryComponent} from "./app/round-history/round-history.component";
import {AuthGuard} from "./app/auth/auth.guard";
import {AuthService} from "./app/auth/auth.service";
import {provideHttpClient} from "@angular/common/http";
import {MapsComponent} from "./app/admin/maps/maps.component";
import {InstallComponent} from "./app/install/install.component";

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/rounds',
    },

    {path: "login", component: SignInComponent},
    {path: "signup", component: SignUpComponent},
    {path: "reset/:email/:token", component: PasswordResetComponent},

    {path: "round/:token", component: RoundComponent, data: {minWidth: '860px'}},

    {path: "unsubscribe", component: UnsubscribeComponent},

    {path: "install", component: InstallComponent},

    {
        path: "rounds",
        component: RoundHistoryComponent,
        canActivate: [AuthGuard],
    },

    {
        path: "mailing",
        component: MailingComponent,
        canActivate: [PermissionsService],
    },

    {
        path: "pinhole/maps",
        component: MapsComponent,
        canActivate: [PermissionsService],
        data: {minWidth: '900px'}
    },

    {
        path: "pinhole",
        component: PinholeComponent,
        canActivate: [PermissionsService],
        data: {minWidth: '900px'}
    },

    {path: '**', redirectTo: '/'},
];

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes),
        provideHttpClient(),
        AuthService
    ]
}).catch(err => console.error(err));
